import { Component, OnInit, ElementRef, ViewChild,ViewEncapsulation,OnChanges,OnDestroy,Input, Output,SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeHtml, SafeResourceUrl } from '@angular/platform-browser';
import {Utils} from '../_util/utils'; 
import { FrmService } from '../inservice/frm.service';
declare var $: any;
@Component({
  selector: 'app-preview',
  templateUrl: './preview.component.html',
  styleUrls: ['./preview.component.css']
})
export class PreviewComponent implements OnInit {
	@Input() content:any;
	@Input() front:any;
	@Input() space1:string;
	@Input() space2:string;
	@Input() space3:string;
	@Input() curReport:any;
	public rptInfo:any;
	public currSign='$';
	public otherTypes=['TABLE','MAP','PHOTOS','LOCKED_CONTENT','COSTTABLE', 'PCATABLE','UNITTABLE'];
	public contents=[];
	public frontpages=[];
	public unitrow=1
	public sec3type1=[0,1,4,5];
	public sec3type2=[2,3]; 
	iframeSrc: SafeResourceUrl | null = null;
	iframeSrc1: SafeResourceUrl | null = null;
	private iframeBlobUrl: string | null = null;
	head1Space='1';
	head2Space='1';
	head3Space='1';
	public PropertyAsReportedHTML:any;  
	public PropertyConditionAssessmentPropertyCoreCharacteristics:any;
	public PropertyConditionAssessmentPropertyCoreCharacteristicsHTML:any;
	public PropertyConditionAssessment:any;
	public PropertyConditionAssessmentHTML:any;
	public frmData:any;
	public PropertyAmenity:any;
	public PropertyTotalRentRollSummary:any;
	public flatDataAmentities:any;
	public flatData:any;
	public flatDataSec2:any;
	public flatDataSec3:any;
	public flatDataSetSec3:any;
	public flatPartySetSec3:any
	public flatDataSec4:any;
	public flatDataSetSec4:any;
	public tableset:any;
	public sec2tablesdata:any[];
	public sec3tablesdata:any[];
	public sec6tablesdata:any[];
	public pcaOp={'term':'Include','multiplier':"",'quantity':0, 'reserve':12, 'age':0, 'decimal':2,'currency':'USD','inflation':2.5,'round':'Round'};
	public costTables:any[];
	public curSec:any;	
	public curCell:any;	
	public cellShow:any;
	public datasrc:boolean;	
	public bedroomList=['0BR', '1BR', '2BR', '3BR', '4BR', '5BR'];
	public bedroomStatus=['O = occupied', 'V = vacant', 'D = down','R = Other'];
	public ORrows=[];
	public repairTotal=0;
	//waterCheck=[false, false, false, false, false];
	waters=['privateWellsDrinkingWater','privateWellsNonDrinkingWater','wasteWaterTreatment', 'privateLiftStations'];
	repairtCount=[false,false,false,false,false, false];
	frmSec:any;
	@ViewChild("frmContent") frmContent: ElementRef;
	constructor(public sanitizer: DomSanitizer,public frmService:FrmService) { }

  ngOnInit(): void {
  }
	
	ngOnChanges(changes: SimpleChanges): void {
       if('content' in changes){
			if(this.content){
				this.contents=this.content;		
				this.iniFrmdata();		
			}		
		}
		if('front' in changes){
			if(this.front){
				this.frontpages=this.front;
			}		
		}
		if('space1' in changes){
			if(this.space1){
				this.head1Space=this.space1;
			}		
		}
		if('space2' in changes){
			if(this.space2){
				this.head2Space=this.space2;
			}		
		}
		if('space3' in changes){
			if(this.space3){
				this.head3Space=this.space3;
			}		
		}
		if('curReport' in changes){
			if(this.curReport){
				this.rptInfo=this.curReport;							
			}		
		}
		
	}
	ngAfterViewInit() {
		if (this.curReport && (this.curReport.PCA_INDICATOR == 'frm1104'||this.curReport.PHASE1_TYPE=='1103')) {
			// build blob and keep raw URL for revoke, pass a SafeResourceUrl to template
			const blob = new Blob([this.getFrmHtml()], { type: 'text/html' });
			this.iframeBlobUrl = URL.createObjectURL(blob);
			this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(this.iframeBlobUrl);
		}else if(this.curReport && this.curReport.PCA_INDICATOR == 'frm1105'){
			// build blob and keep raw URL for revoke, pass a SafeResourceUrl to template
			const blob = new Blob([this.getFrmHtml()], { type: 'text/html' });
			this.iframeBlobUrl = URL.createObjectURL(blob);
			this.iframeSrc1 = this.sanitizer.bypassSecurityTrustResourceUrl(this.iframeBlobUrl);
		}
	}
	ngOnDestroy() {
		// revoke the raw blob URL only
		if (this.iframeBlobUrl) {
			URL.revokeObjectURL(this.iframeBlobUrl);
			this.iframeBlobUrl = null;
		}
	}
	trackByFuntion(index, item) {
		return index;
	}

	hasSpecialSignatureFormat(doc: any): boolean {
		if (!doc) return false;		
		if (doc.signs) {
		  return doc.signs.some((s: any) => 
			this.rptInfo && 
			this.rptInfo['SPECIAL_SIGNATURE_FORMAT'] === 'Y'
		  );
		}
		if (doc.SUB_SECTIONS) {
		  return doc.SUB_SECTIONS.some((subDoc: any) => this.hasSpecialSignatureFormat(subDoc));
		}
		
		return false;
	}

	processSignatureTemplate(htmlSec: any): any {
		if (!htmlSec || !htmlSec.changingThisBreaksApplicationSecurity) {
			return htmlSec;
		}
		let htmlString = htmlSec.changingThisBreaksApplicationSecurity;
		
		htmlString = htmlString.replace(/margin-left:\s*10px;/g, `display: block; margin:0 auto`);
		
		return {
			...htmlSec,
			changingThisBreaksApplicationSecurity: htmlString
		};
	}
	USDollar = new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency: 'USD',
	});
	USDollar1 = new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency: 'USD',
		maximumFractionDigits: 0, 
  		minimumFractionDigits: 0,
	});
	getFrmHtml(){
		let html:string='';
		html=this.frmService.pdfHead;
		html+=this.frmContent.nativeElement.innerHTML;
		html+='</main></body></html>';//console.log(html)
		return html;
	}
	iniFrmdata(){
		if(this.curReport&&this.curReport.PCA_INDICATOR=='frm1104'){
			if(this.contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit.length==0){
				this.unitrow=1
			}else{
				this.unitrow=Math.ceil(this.contents[1].SUB_SECTIONS[2].data.PropertyResidentialRentalUnit.length/4);      
			}
			return
		}else if(this.curReport&&this.curReport.PHASE1_TYPE&&this.curReport.PHASE1_TYPE=='1103'){
			if(this.contents[2].SUB_SECTIONS[0].data.units.length==0){
				this.unitrow=5;
				for(let i=0; i<20; i++){
					this.contents[2].SUB_SECTIONS[0].data.units.push("");
				} 
			}else{
				this.unitrow=Math.ceil(this.contents[2].SUB_SECTIONS[0].data.units.length/4);  
			
			}
			return
		}
		for(let sec of this.contents){
					if(sec.TYPE=='1105'&&(sec.id='frm_sec')){
						this.frmSec=sec;
						sec['searchstring']=sec.id+Utils.uniqueIdGenerator();
						this.frmData = JSON.parse(JSON.stringify(sec.frmData));			
						//if(this.frmData['AccountNameHTML']){
						//this.AccountNameHTML=this.frmData['AccountNameHTML'];
						//}
						if(!this.frmData['sec4OutPutData']){
							this.frmData['sec4OutPutData']=[0, '$0'];
						}
						if(this.frmData['repairtCount']){
							this.repairtCount=this.frmData['repairtCount'];
						}
						if(this.frmData['flatPartySetSec3']){
							this.flatPartySetSec3=this.frmData['flatPartySetSec3'];
						  }
						 if(this.frmData['repairtCount']){
						   this.repairtCount= this.frmData['repairtCount'];
						  }
						if(this.frmData['sec2tablesdata']){
						this.sec2tablesdata=this.frmData['sec2tablesdata'];
						}else{
						this.frmData['sec2tablesdata']=this.sec2tablesdata;
						}
						if(this.frmData['sec3tablesdata']){
						this.sec3tablesdata=this.frmData['sec3tablesdata'];
						}else{
						this.frmData['sec3tablesdata']=this.sec3tablesdata;
						}
						if(this.frmData['sec6tablesdata']){
						this.sec6tablesdata=this.frmData['sec6tablesdata'];
						}else{
						this.frmData['sec6tablesdata']=this.sec6tablesdata;
						}
						if(this.frmData['ORrows']){
							this.ORrows=this.frmData['ORrows'];
						}
						
						this.PropertyAsReportedHTML=this.frmData.PropertyAsReportedHTML;
						this.PropertyConditionAssessmentPropertyCoreCharacteristicsHTML=this.frmData.PropertyConditionAssessmentPropertyCoreCharacteristicsHTML;
						this.PropertyConditionAssessmentHTML=this.frmData.PropertyConditionAssessmentHTML;
						this.toSanitizer();
						this.PropertyAmenity=this.frmData.PropertyAmenity;
						//this.PropertyAsReported=this.frmData.PropertyAsReported;
						this.PropertyConditionAssessmentPropertyCoreCharacteristics=this.frmData.PropertyConditionAssessmentPropertyCoreCharacteristics;
						this.toFlat(this.frmData.PropertyConditionAssessment[0]);
						this.PropertyConditionAssessment=this.frmData.PropertyConditionAssessment;
						
						let fields=['AtInpectionWeatherDescription','PrelimInspectionDate','FinalAsmntDate','FirmAddressLineText','FirmCityName','FirmName','FirmPostalCode','FirmStateUspsCode','InspectorName','InspectorPhoneNumber','InspectorTitle','OnsiteContactName','OnsiteContactPhoneNumber',];
						//let fields=['AtInpectionWeatherDescription','FirmAddressLineText','FirmCityName','FirmName','FirmPostalCode','FirmStateUspsCode','InspectorName','InspectorPhoneNumber','InspectorTitle','OnsiteContactName','OnsiteContactPhoneNumber',];
						
						for(let field of fields){
							if(!(field=="PrelimInspectionDate"||field=="FinalAsmntDate")&&this.PropertyConditionAssessmentHTML[field]&&this.PropertyConditionAssessmentHTML[field].html.length>0){
								if($(this.PropertyConditionAssessmentHTML[field].html).find('.placeholder').length>0){
									this.PropertyConditionAssessment[0][field]=$(this.PropertyConditionAssessmentHTML[field].html.replace('<p>','').replace('</p>',''))[0].innerHTML;	
								}else{
									this.PropertyConditionAssessment[0][field]=this.PropertyConditionAssessmentHTML[field].html.replace('<p>','').replace('</p>','');
								}
								//this.PropertyConditionAssessment[0][field]=$(this.PropertyConditionAssessmentHTML[field].html.replace('<p>','').replace('</p>',''))[0].innerHTML;
							}else if(field=="PrelimInspectionDate"||field=="FinalAsmntDate") {
								this.PropertyConditionAssessment[0][field]=this.PropertyConditionAssessmentHTML[field];
							}
						}
						this.PropertyTotalRentRollSummary=this.frmData.PropertyTotalRentRollSummary;
						
						if(this.PropertyTotalRentRollSummary[0].PropertyResidentialRentalUnit.length==0){
						this.unitrow=1
						}else{
							this.unitrow=Math.ceil(this.PropertyTotalRentRollSummary[0].PropertyResidentialRentalUnit.length/4);      
						}
					}
				}	
	}
	resizeIframe(event: Event) {
		const iframe = event.target as HTMLIFrameElement;
		const doc = iframe.contentDocument || iframe.contentWindow?.document;

		if (!doc) return;

		iframe.style.height = doc.documentElement.scrollHeight + 160 +'px';
	}
	toFlat(alldata){
		this.flatDataAmentities=[];
		for(let data of this.PropertyAmenity){
		  this.flatDataAmentities.push(data.AmenityType);
		}
		
		this.flatData=[];
		for(let data of alldata.PropertyConditionAssessmentBuildingAndMaterials){
		   if(data.CatSubtype){
			  let text=data.CatType+';'+data.CatSubtype+';'+data.ItemType;
			  this.flatData.push(text);
			}else{
			  let text=data.CatType+';'+data.ItemType
			  this.flatData.push(text);
			}    
		}
	   // console.log(this.flatData);
		this.flatDataSec3={};
		this.flatDataSetSec3={};//console.log(alldata.PropertyConditionAssessmentWaterTreatment)
		for(let i=0; i<this.waters.length; i++){
			//if(i==1){
			//   let item={"PptyWaterSystemType": "privateWellsNonDrinkingWater",
			//	"WaterSystemOperationsDescription": ""};
			//	this.flatDataSec3[this.waters[i]]=['privateWellsNonDrinkingWater'];
			//	this.flatDataSetSec3[this.waters[i]]=[item];               
			//}else{
			  this.flatDataSec3[this.waters[i]]=[];
			  this.flatDataSetSec3[this.waters[i]]=[]; 
			//}      
		  }
		if(alldata.PropertyConditionAssessmentWaterTreatment.length>0){
		for(let data of alldata.PropertyConditionAssessmentWaterTreatment){//console.log(data)
		  if(this.flatDataSec3[data.PptyWaterSystemType]){
			if(data.WaterSystemMaintenanceResponsiblePartyType){
			  this.flatDataSec3[data.PptyWaterSystemType].push(data.WaterSystemMaintenanceResponsiblePartyType);
			}else if(data.PptyWaterSystemSubType){
				this.flatDataSec3[data.PptyWaterSystemType].push(data.PptyWaterSystemSubType);
			  }else if(data.PptyWaterSystemType=="privateWellsNonDrinkingWater"){
				this.flatDataSec3[data.PptyWaterSystemType][0]=data.PptyWaterSystemType;
			}else{
			  this.flatDataSec3[data.PptyWaterSystemType].push(data.WaterSystemAsmntItemType);
			  
			}
			if(data.PptyWaterSystemType=="privateWellsNonDrinkingWater"){
				this.flatDataSetSec3[data.PptyWaterSystemType][0]=data;
			}else{
				this.flatDataSetSec3[data.PptyWaterSystemType].push(data);
			} 
			
		  }else{
			this.flatDataSec3[data.PptyWaterSystemType]=[];
			this.flatDataSetSec3[data.PptyWaterSystemType]=[];
			this.flatDataSetSec3[data.PptyWaterSystemType].push(data);
			if(data.WaterSystemMaintenanceResponsiblePartyType){
			  this.flatDataSec3[data.PptyWaterSystemType].push(data.WaterSystemMaintenanceResponsiblePartyType);
			}else if(data.PptyWaterSystemSubType){
			  this.flatDataSec3[data.PptyWaterSystemType].push(data.PptyWaterSystemSubType);
			}else if(data.PptyWaterSystemType=="privateWellsNonDrinkingWater"){
				this.flatDataSec3[data.PptyWaterSystemType][0]=data.PptyWaterSystemType;
			}else{
			  this.flatDataSec3[data.PptyWaterSystemType].push(data.WaterSystemAsmntItemType);
			  
			}
		  }
		 /* for(let i=0; i<this.waters.length; i++){
			if(this.flatDataSec3[this.waters[i]]&&this.flatDataSec3[this.waters[i]].length>0){
			  this.waterCheck[i]=true;
			}else if(this.flatPartySetSec3[this.waters[i]]){
				this.flatDataSec3[this.waters[i]]=[];
				this.flatDataSetSec3[this.waters[i]]=[];
				this.waterCheck[i]=true;
			  }else{
			  this.waterCheck[i]=false;
			}
		  }*/
		}
	}

		this.flatDataSec4={};
		this.flatDataSetSec4={};
		if(alldata.PropertyConditionAssessmentManufacturedHousing.length>0){
			for(let data of alldata.PropertyConditionAssessmentManufacturedHousing){
				if(this.flatDataSec4["PropertyConditionAssessmentManufacturedHousing"]){
				  this.flatDataSec4["PropertyConditionAssessmentManufacturedHousing"].push(data.ViolationType);
				  this.flatDataSetSec4["PropertyConditionAssessmentManufacturedHousing"].push(data);
				}else{
				  this.flatDataSec4["PropertyConditionAssessmentManufacturedHousing"]=[];
				  this.flatDataSetSec4["PropertyConditionAssessmentManufacturedHousing"]=[];
				  this.flatDataSetSec4["PropertyConditionAssessmentManufacturedHousing"].push(data);
				  this.flatDataSec4["PropertyConditionAssessmentManufacturedHousing"].push(data.ViolationType);
					
				  
				}
			  }
		}else{
			this.flatDataSec4["PropertyConditionAssessmentManufacturedHousing"]=[];
			this.flatDataSetSec4["PropertyConditionAssessmentManufacturedHousing"]=[];
		}
		
		if(alldata.ManufacturedHousingUtility.length>0){
			for(let data of alldata.ManufacturedHousingUtility){
			if(this.flatDataSec4['ManufacturedHousingUtility']){
				this.flatDataSec4['ManufacturedHousingUtility'].push(data.UtilityServiceType);
				this.flatDataSetSec4['ManufacturedHousingUtility'].push(data);
			}else{
				this.flatDataSec4['ManufacturedHousingUtility']=[];
				this.flatDataSetSec4['ManufacturedHousingUtility']=[];
				this.flatDataSetSec4['ManufacturedHousingUtility'].push(data);
				this.flatDataSec4['ManufacturedHousingUtility'].push(data.UtilityServiceType);		
			}
			}
		}else{
			this.flatDataSec4['ManufacturedHousingUtility']=[];
			this.flatDataSetSec4['ManufacturedHousingUtility']=[];
		}
		
		//console.log(this.flatDataSec4);
		//console.log(this.flatDataSetSec4);
	
	  }
	toSanitizer(){
		if(this.PropertyAsReportedHTML){
		  let items=[this.PropertyAsReportedHTML,this.PropertyConditionAssessmentHTML, this.PropertyConditionAssessmentPropertyCoreCharacteristicsHTML];
		  for(let item of items){
			let keys=Object.keys(item);
			for(let key of keys){
			  if(!item[key].secHtml&&item[key].html){
				item[key].secHtml=this.sanitizer.bypassSecurityTrustHtml(item[key].html);
			  }
			}
			
		  }
		  
		}
	
	  }
}
